//Library imports
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Switch } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { activateAsset } from "modules/Campaigns/Emails/actions";

interface ISwitchItem {
  active?: boolean;
  assetId?: number;
  onSwitch?: (value: any) => void;
  isActive?: string;
}

const SwitchItem: React.FC<ISwitchItem> = ({ active, onSwitch, assetId, isActive }) => {
  const switchState = useSelector((state: RootState) => state.assetDetails.is_active);
  const [switchValue, setSwitchValue] = useState(switchState);
  const asset_id = assetId?.toString();
  const onChangeHandler = (value: boolean) => {
    setSwitchValue(value);
    if (onSwitch) {
      onSwitch(value);
    }
    if (asset_id) activateAsset(asset_id, value ? "1" : "0");
  };

  useEffect(() => {
    setSwitchValue(switchState);
  }, [switchState]);

  return (
    <>
      <div className="d-flex align-items-center">
        <TextDiv>{switchValue ? "Active" : "Inactive"}</TextDiv>
        <Switch
          onChange={(e) => onChangeHandler(e)}
          checked={switchValue}
          checkedChildren="On"
          unCheckedChildren="Off"
        />
      </div>
    </>
  );
};
export default SwitchItem;

const TextDiv = styled.div`
  vertical-align: middle;
  margin-right: 0.5em;
  color: #717171;
  font-weight: 700;
  font-size: 16px;
  font-family: "robotoregular";
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 12px;
  }
`;
